<template>
  <div class="navbar">
    <FilterNavigationItem 
      @click="changeOption(option)"
      v-for="option in options" 
      :isSelectedOption="option.id == selectedOption?.id"
      :image="option.image"
      :inactive="option.imageblack"
      :key="option.id" 
      :text="option.name" />
  </div>
</template>

<script>
import FilterNavigationItem from '@/components/filterNavigation/filterNavigationItem.vue'


export default {
  name: 'FilterNavigation',
  emits:["setOption"],
  props:["options","selectedOption"],
  components:{
    FilterNavigationItem
  },
  methods:{
    changeOption(option){
      this.$emit("setOption",option);
    },
  }
}
</script>

<style scoped>
.navbar{
  background-color: #f3f4f6;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
  z-index: 99999;
}
</style>